import { render, staticRenderFns } from "./ProgrammingResults.vue?vue&type=template&id=2ce580ef&"
import script from "./ProgrammingResults.vue?vue&type=script&lang=js&"
export * from "./ProgrammingResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports